import { render, staticRenderFns } from "./InactiveBooks.vue?vue&type=template&id=7328ccb1&scoped=true"
import script from "./InactiveBooks.vue?vue&type=script&lang=js"
export * from "./InactiveBooks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7328ccb1",
  null
  
)

export default component.exports